import React, { useContext, useMemo } from "react";
import styles from "./Carrinho.module.scss";
import { CarrinhoItem } from "shared/components/carrinhoitem/CarrinhoItem";
import { CartContext } from "shared/contexts/Cart/CartContext";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { formatarMoeda } from "shared/utils/money";
import { featureFlags } from "shared/config/featureFlags";

export const Carrinho: React.FC = () => {
  const { cart } = useContext(CartContext);
  const navigate = useNavigate();

  const carrinhoVazio = cart.length === 0;

  /* ================================
     🔹 FRETE
  ================================ */

  const freteTotal = 0;
  const freteTexto = carrinhoVazio
    ? "—"
    : "Será calculado";

  /* ================================
     🔹 IR PARA CONFIRMAR PEDIDO
  ================================ */

  const hdleNext = () => {  navigate("/carrinho/confirmar", {
      state: {
        frete: freteTotal,
      },
    });
  };

/* ================================
   🔹 SUBTOTAL
================================ */

const subtotalCentavos = useMemo(() => {
  return cart.reduce((acc, item) => acc + item.total, 0);
}, [cart]);

const subtotal = formatarMoeda(subtotalCentavos);

/* ================================
   🔹 TOTAL
================================ */

const totalFinal = formatarMoeda(
  subtotalCentavos + freteTotal
);
  return (
    <PageContainer title="Meu Carrinho" icon={<ShoppingCart size={18} />}>
      <div className={styles.page}>
        {carrinhoVazio ? (
          <div className={styles.listaProdutosVazio}>
            <div className={styles.containerImgVazio}>
              <img src="/imagens/carrinhoVazio.png" alt="Carrinho vazio" />
            </div>

            <p className={styles.fraseVazio}>
              Nenhum produto <br /> no seu carrinho
            </p>

            <p className={styles.pLink}>
              <a href="/" className={styles.link}>
                Clique aqui
              </a>{" "}
              para ir para a loja
            </p>
          </div>
        ) : (
          <div className={styles.listaProdutos}>
            {cart.map((item) => (
              <CarrinhoItem key={item.id} item={item} />))}
          </div> )}

        {!carrinhoVazio && (
          <div className={styles.containerFinalizar}>

            {/* VALORES */}
            <div className={styles.containerValores}>
              <div className={styles.containerSubTotal}>
                <p className={styles.subTotal}>SubTotal</p>
                <strong>{subtotal}</strong>
              </div>

              <div className={styles.containerFrete}>
                <p className={styles.subTotal}>Frete</p>
                <p className={styles.subTotalValue}>{freteTexto}</p>
              </div>

              <div className={styles.containerTotal}>
                <p className={styles.total}>Total</p>
                <p className={styles.total}>{totalFinal}</p>
              </div>

              {/* BOTÃO */}
              {featureFlags.checkout && (
                <div className={styles.containerBtns}>
                  <button className={styles.finalizar}  onClick={hdleNext}>
                    Confirmar Pedido
                  </button>
                </div>
              )}

              <button className={styles.btnAdc}>
                Adicionar mais itens
              </button>
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
};